let router = [
	{
		title: '分享页面',
		paramsName: 'sharePage',
		params: 'sharePage/:id?',
		name: 'pythonProject/sharePage',
		grade: 1
	},
	{
		title: '体验课程',
		paramsName: 'experienceH5',
		params: 'experienceH5/:id?',
		name: 'pythonProject/experienceH5',
		grade: 1
	},
	{
		title: '免费课程',
		paramsName: 'freeCourseH5',
		params: 'freeCourseH5/:id?',
		name: 'pythonProject/freeCourseH5',
		grade: 1
	},
	{
		title: '上课指引',
		paramsName: 'experienceGuide',
		params: 'experienceGuide/:id?',
		name: 'pythonProject/experienceGuide',
		grade: 1
	},
	{
		title: '基础课程',
		paramsName: 'basicsCourseH5',
		params: 'basicsCourseH5/:id?',
		name: 'pythonProject/basicsCourseH5',
		grade: 1
	},
	{
		title: '基础课程',
		paramsName: 'basicsCourseV2',
		params: 'basicsCourseV2/:id?',
		name: 'pythonProject/basicsCourseV2',
		grade: 1
	},
	{
		title: '基础课程',
		paramsName: 'basicsCourseH5Co',
		params: 'basicsCourseH5Co/:id?',
		name: 'pythonProject/basicsCourseH5Co',
		grade: 1
	},
	{
		title: 'python入门实战课',
		paramsName: 'experience',
		params: 'experience/:id?',
		name: 'pythonProject/experience',
		grade: 1
	},
	{
		title: 'python入门实战课',
		paramsName: 'experience',
		params: 'experienceV2/:id?',
		name: 'pythonProject/experience',
		grade: 1
	},
	{
		title: '派森编程入学测试',
		paramsName: 'pythonTestPage',
		params: 'pythonTestPage/:id?',
		name: 'pythonProject/pythonTestPage',
		grade: 1
	},
	{
		title: '派森编程调查问卷',
		paramsName: 'questionnaire',
		params: 'questionnaire/:id?',
		name: 'pythonProject/pythonQuestion',
		grade: 1
	},
	{
		title: '派森编程',
		paramsName: 'alipay',
		params: 'alipay/:id?',
		name: 'pythonProject/alipay',
		grade: 1
	},
	{
		title: '基础语法 + 爬虫实战编程',
		paramsName: 'basicAndReptiles',
		params: 'basicAndReptiles/:id?',
		name: 'pythonProject/course/basicAndReptiles',
		grade: 1
	},
	{
		title: 'python零基础全能进阶课VIP',
		paramsName: 'allcourse',
		params: 'allcourse/:id?',
		name: 'pythonProject/course/allcourse',
		grade: 1
	},
	{
		title: 'Python自动化办公进阶课',
		paramsName: 'autooffice2020',
		params: 'autooffice2020/:id?',
		name: 'pythonProject/course/autooffice2020',
		grade: 1
	},
	{
		title: '爬虫实战编程',
		paramsName: 'reptiles',
		params: 'reptiles/:id?',
		name: 'pythonProject/course/reptiles',
		grade: 1
	}
]
export default router



// WEBPACK FOOTER //
// ./src/route/pythonProject.js